export default __webpack_public_path__ + "static/imoneybus_cover-small_1-ca1b87857eaee619dc6a5a7d40a09c00.webp";